export const getIconSrc = (icon) => {
  if (!icon) {
    return `${process.env.PUBLIC_URL}/images/icons/transactions_blue.svg`;
  }

  if (icon.startsWith("http") || icon.startsWith("data:")) {
    return icon;
  }

  return `${process.env.PUBLIC_URL}/images/icons/${icon}`;
};

export const getInitials = (name = "") => {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
};

const getHexLuminance = (hexColor) => {
  if (!hexColor || typeof hexColor !== "string") return null;

  const normalizedHex = hexColor.replace("#", "").trim();
  const fullHex =
    normalizedHex.length === 3
      ? normalizedHex
          .split("")
          .map((char) => `${char}${char}`)
          .join("")
      : normalizedHex;

  if (!/^[0-9a-fA-F]{6}$/.test(fullHex)) return null;

  const red = parseInt(fullHex.slice(0, 2), 16);
  const green = parseInt(fullHex.slice(2, 4), 16);
  const blue = parseInt(fullHex.slice(4, 6), 16);

  return (0.299 * red + 0.587 * green + 0.114 * blue) / 255;
};

export const getInitialsIconSrc = (
  name,
  backgroundColor = "#EAF5FF",
  textColor,
) => {
  const initials = getInitials(name) || "?";
  const safeBackgroundColor = backgroundColor || "#EAF5FF";
  const backgroundLuminance = getHexLuminance(safeBackgroundColor);
  const safeTextColor =
    textColor || (backgroundLuminance !== null && backgroundLuminance < 0.45
      ? "#FFFFFF"
      : "#003B66");
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <rect width="32" height="32" rx="16" fill="${safeBackgroundColor}" />
      <text x="50%" y="54%" dominant-baseline="middle" text-anchor="middle" fill="${safeTextColor}" font-family="Rubik, Arial, sans-serif" font-size="12" font-weight="700">${initials}</text>
    </svg>
  `;

  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};
